import React from "react"
import { graphql } from "gatsby"
import parse from "html-react-parser"
import LayoutIndex from "../components/Layout/LayoutIndex"
import ContentDetails from "../components/ContentDetail/ContentDetail"
import { pageDescription } from "../utilities/utility"

export const Head = ({ data: { contentPage, site } }) => (
  <>
      <title>{contentPage.title} | {site.siteMetadata.title}</title> 
      <meta name="description" content={pageDescription(contentPage.content)} />
      <meta name="robots" content="index, follow" />
  </>
)

const contentDetail = ({ data }) => {

	return (
		<LayoutIndex title={data.contentPage.title}>
			<ContentDetails>
				{parse(data.contentPage.content)}
			</ContentDetails>
		</LayoutIndex>
	)
}

export default contentDetail

export const pageQuery = graphql`
  query contentById(
    # these variables are passed in via createPage.pageContext in gatsby-node.js
    $id: String!
  ) {
    # selecting the current post by id
    contentPage: wpPage(id: { eq: $id }) {
      id
      content
      title
    }
    site {
      siteMetadata {
        title
        description
        author
      }
    }
  }
`

